import React from 'react';
import ScienceIcon from '@mui/icons-material/Science';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true },
  {
    key: 'modeOfActionGroupId',
    label: 'Mode of Action Group',
    type: 'reference',
    referenceApiPath: '/api/mode-of-action-groups',
    displayKey: 'modeOfActionGroupName',
    referenceSecondaryKey: 'description',
  },
];

const ActiveIngredientManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Active Ingredient Management"
    icon={<ScienceIcon />}
    apiPath="/api/active-ingredients"
    fields={fields}
    entityLabel="Active Ingredient"
  />
);

export default ActiveIngredientManagement;
